import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"

const SchemaComponent = ({ description, breadcrumb, pageType, keywords }) => {
  const { pathname } = useLocation()
  const { site } = useStaticQuery(query)
  const { siteUrl } = site.siteMetadata

  const webPageSchema = {
    "@context": "http://schema.org",
    "@type": pageType,
    url: `${siteUrl}${pathname}`,
  }

  if (description) {
    webPageSchema.description = description
  }

  if (keywords?.length > 0) {
    webPageSchema.keywords = keywords
  }

  if (breadcrumb) {
    webPageSchema.breadcrumb = breadcrumb
  }

  const organizationSchema = {
    "@context": "http://schema.org",
    "@type": "Organization",
    "@id": "https://www.obicis.com/#organization",
    description:
      "Obicis is a software company engaged in IT consulting and software development for the web, mobile devices, and enterprise environments.",
    duns: "595569326",
    founder: {
      "@type": "Person",
      "@id": "https://hrvoje.maracic.net/#person",
      name: "Hrvoje Maracic",
      sameAs: ["https://www.linkedin.com/in/hrvojemaracic"],
    },
    logo: {
      "@type": "ImageObject",
      url: "https://www.obicis.com/og-obicis.png",
      width: "1200",
      height: "630",
    },
    name: "Obicis",
    foundingDate: "2014-07-10",
    url: "https://www.obicis.com",
    sameAs: ["https://www.linkedin.com/company/obicis"],
  }

  const schemas = [webPageSchema]

  if (pathname === "/") {
    schemas.push(organizationSchema)
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemas)}</script>
      <link rel="canonical" href={`https://www.obicis.com${pathname}`} />
    </Helmet>
  )
}
export default SchemaComponent
SchemaComponent.propTypes = {
  description: PropTypes.string,
  breadcrumb: PropTypes.object,
  pageType: PropTypes.string,
  keywords: PropTypes.arrayOf(PropTypes.string),
}
SchemaComponent.defaultProps = {
  description: undefined,
  breadcrumb: undefined,
  pageType: "WebPage",
  keywords: [],
}
const query = graphql`
  query SchemaComponent {
    site {
      siteMetadata {
        siteUrl: url
      }
    }
  }
`
